<template>
  <AllegroJsonForm
    title="Allegro - Dodaj osobę odpowiedzialną"
    crumbLabel="Dodaj osobę odpowiedzialną"
    :settingsCrumb="true"
    submitAction="createAllegroResponsibleProducer"
    submitGetter="getAllegroResponsibleProducerCreateData"
    backRoute="/allegro/accounts"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroResponsibleProducerPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroResponsibleProducerCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroResponsibleProducerPermissionsConst.add,
      fields: [{ key: "name", label: "Nazwa własna", required: true }],
    };
  },
};
</script>
